var autocompleteCss = '.autocomplete-suggestions {\n'
    + '    position: absolute!important;\n'
    + '    border: 1px solid #999;\n'
    + '    background: #FFF;\n'
    + '    overflow: auto;\n'
    + '}\n'
    + '.autocomplete-suggestion {\n'
    + '    padding: 2px 5px;\n'
    + '    overflow: hidden;\n'
    + '    text-align: left;\n'
    + '    width: 100%;\n'
    + '    border-bottom: 1px solid #f3f4f5;\n'
    + '}\n'
    + '.autocomplete-suggestions { border: 1px solid #999; background: #FFF; overflow: auto; font-size:12px; }\n'
    + '.autocomplete-suggestion { padding: 3px 5px; text-align: left; border-bottom:1px solid #ccc; cursor: pointer; }\n'
    + '.autocomplete-suggestion span.inactive{ color:#999; font-style:italic }\n'
    + '.autocomplete-no-suggestion { padding: 3px 5px; text-align: left; border-bottom:1px solid #ccc; color:#999; }\n'
    + '.autocomplete-selected { background: #F0F0F0; }\n'
    + '.autocomplete-suggestions strong { color: #0073AA; }\n'
    + '.autocomplete-group { padding:0; }\n'
    + '.autocomplete-group { padding: 15px 5px 3px; display: block; border-bottom: 1px solid #ccc; color:#000; background-color: #F0F0F0; font-weight: bold; }';

export default function getAutocompleteCss() {
    return autocompleteCss;
}